import { useMutation, useQuery } from "react-query";
import { useParams, useHistory } from "react-router";
import axiosInstance from "../../config/axios-instance";
import proto_illustration from "../../img/Prototype.svg";
import backArrow from "../../img/backArrow.png";

import {
  Select,
  Spin,
  Steps,
  List,
  Avatar,
  Breadcrumb,
  Button,
  Input,
  Popover,
  Tooltip,
  Popconfirm,
  message,
  Modal,
  Badge,
  Tag,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faImage } from "@fortawesome/free-solid-svg-icons";

import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import avatar_placeholder from "../../img/avatar_placeholder.jpg";
import { UserOutlined } from "@ant-design/icons";
import { history } from "../..";
import useWindowWidth from "../../config/useWindowWidth";
import moment from "moment";
import { useState } from "react";
import {
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  DatabaseOutlined,
  EyeOutlined,
  CheckSquareOutlined,
} from "@ant-design/icons";
import LightBoxImage from "./LightBoxImage";
import { CancelOrderDrawer } from "../MyOrderConfirmation/CancelOrderDrawer";
import {
  approveOptionAndComment,
  rejectOrAcceptProto,
} from "../../actions/order-actions/actions";
import { MyNotif } from "../NotifIcons/NotifIcons";
const { Step } = Steps;
const { Option } = Select;
const OrderProgress = () => {
  const params = useParams<any>();
  const routerHistory = useHistory();
  const [status, setStatus] = useState("");
  const [qty, setQty] = useState("");
  const [size_qty, setSizeQty] = useState("");

  const fetchOptions = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/article_options/${params.option_id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };
  const fetchArticle = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/order_articles/${params.article_id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };
  const fetchDirectOrder = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/direct_orders/${params.order_id}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  const downloadZipFileFromLaravel = (type: any) => {
    axiosInstance({
      url: `/download-file-option-order/${params.option_id}/${type}`,
      method: "GET",

      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.zip"); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };
  const {
    isLoading: loadingOrder,
    data: direct_order,
    refetch,
  } = useQuery("single_order", () => fetchDirectOrder(), {
    keepPreviousData: true,
  });
  const { isLoading: loadingArticle, data: article } = useQuery(
    "article",
    () => fetchArticle(),
    {
      keepPreviousData: true,
    }
  );

  const { isLoading, data: option } = useQuery<any>(
    "option",
    () => fetchOptions(),
    {
      keepPreviousData: true,
    }
  );

  const selectHandleChange = (e: any) => {
    setStatus(e);
  };

  /*   const edit = () => {
    console.log("test");
  }; */

  const [isOpened, setIsOpened] = useState(false);
  function edit() {
    setIsOpened((wasOpened) => !wasOpened);
  }

  const [proto, setProto] = useState("");
  const [comment, setComment] = useState("");

  const [startDate, setStartDate] = useState("");
  const [shippingDate, setShippingDate] = useState("");
  const [datetirmswearhouse, setTirmswearhouse] = useState("");
  const [datefabricwearhouse, setFabricwearhouse] = useState("");
  const [deliverydate, setDeliveryDate] = useState("");
  const [selectdStep, setSelectdStep] = useState("");
  const [isVisible, setIsVisible] = useState(false);

  function handleChangeProto(e: any) {
    setProto(e.target.value);
  }

  function handleChangeStartDate(e: any) {
    setStartDate(e.target.value);
  }
  function handleChangeShippingDate(e: any) {
    setShippingDate(e.target.value);
  }

  function handleChangeDateTirmswearhouse(e: any) {
    setTirmswearhouse(e.target.value);
  }

  function handleChangeDateFabricwearhouse(e: any) {
    setFabricwearhouse(e.target.value);
  }
  function handleChangeDeliveryDate(e: any) {
    setDeliveryDate(e.target.value);
  }

  const showCancelDrawer = () => {
    setIsVisible(true);
  };
  const {
    mutateAsync: approveOptAndComment,
    isLoading: approvingAndCommentLoading,
  } = useMutation(approveOptionAndComment);
  const {
    mutateAsync: rejectOrAcceptPrototype,
    isLoading: rejectOrAcceptProtoLoading,
  } = useMutation(rejectOrAcceptProto, {
    onSuccess: (res) => {
      MyNotif(`Option ${res}ed and comments added successfully`, "success");
      refetch();
    },
  });
  const valider = async (status: any) => {
    let token = localStorage.getItem("token");
    console.log(proto);

    const { data: response } = await axiosInstance({
      method: "put",
      url: `/article_options/admin/${params.option_id}`,
      data: {
        status_id: status,
        proto: proto,
        start_production_date: startDate,
        shipping_date: shippingDate,
        date_trims_wearhouse: datetirmswearhouse,
        date_fabric_wearhouse: datefabricwearhouse,
        delivery_date: deliverydate,
        qty: qty,
        size_qty: size_qty,
        comment: "Approved:" + comment,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    window.location.reload();
    return "ok";
  };

  const next = async (status: any) => {
    let token = localStorage.getItem("token");

    const { data: response } = await axiosInstance({
      method: "put",
      url: `/article_options/next/${params.option_id}`,
      data: {
        status_id: status,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    window.location.reload();
    return "ok";
  };

  const approve = async (id: any, status_id: any) => {
    let token = localStorage.getItem("token");
    const { data: response } = await axiosInstance({
      method: "post",
      url: `/article_options/addCommentApprove/${params.option_id}`,
      data: {
        client_id: id,

        status_id: status_id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(status_id);

    window.location.reload();
    return "ok";
  };
  const onChange = (value: any) => {
    console.log(`selected ${value}`);
    setSelectdStep(value);
    showConfirm(value);
  };
  const { confirm } = Modal;
  function showConfirm(value: any) {
    confirm({
      title: "You are moving to the selected step, Proceed... ?",
      onOk() {
        approve(direct_order?.data.client.id, option.data.status.id);
        next(value);
      },
      onCancel() {
        console.log("Cancel");
        setSelectdStep("1");
      },
    });
  }

  const onSearch = (value: any) => {
    console.log("search:", value);
  };

  const notApprovedOption = async (feedback: string = "") => {
    console.log(`Option ${option?.data.name} is not approved!!`);
    var option_id = option?.data.id;
    if (!feedback) {
      approveOptAndComment({
        article_option_id: option_id,
        comment: `Not Approved: ${comment}`,
        status_id: 6,
      });
    } else {
      await approveOptAndComment({
        article_option_id: option_id,
        comment: `Not Approved: ${comment}`,
        status_id: 6,
        feedback,
      });
    }
    await rejectOrAcceptPrototype({
      response: "reject",
      id: +option_id,
      comment: `Not Approved: ${comment}`,
    });

    setIsVisible(false);
    setComment("");
    setTimeout(() => {}, 2000);
  };
  const [step, setSetp] = useState(option?.data.status.pivot.name);

  const width = useWindowWidth();
  const stepName = ["PROTO", "PRE SMS", "SMS", "OK PROD", "PRODUCTION"];
  return isLoading ? (
    <div
      style={{ width: "100%", minHeight: "100vh" }}
      className="d-flex justify-content-center align-items-center"
    >
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <div className="row myorder_confirmation" style={{ minHeight: "100vh" }}>
      <div
        className="col-12 col-md-5 p-0 d-flex align-items-center"
        style={{ background: "#fcfdff", height: "100%" }}
      >
        {/* <img
          src={
            option.data.status.pivot.proto
              ? option.data.status.pivot.proto
              : proto_illustration
          }
          alt="prototype"
          className="proto_img img-fluid"
          style={{
            objectFit: option.data && option.data.proto ? "contain" : "cover",
          }}
        /> */}

        <iframe
          src={
            option.data.status.pivot.proto
              ? option.data.status.pivot.proto
              : proto_illustration
          }
          style={{
            width: "100%",
            height: "calc(100vh - 227px)",
            border: "none",
          }}
        />
      </div>
      <div className="col-12 col-md-7 proto_container pl-3">
        <div
          className=" m-4"
          style={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className="proto_header">
            <img
              src={backArrow}
              className="back_arrow_folder"
              alt="back arrow"
              onClick={() => history.back()}
            />
            <h1>Orders</h1>
          </div>
          <div>
            <div>
              <Tooltip
                placement="bottom"
                title={isOpened == false ? "Update" : "View"}
              >
                <Button
                  type="ghost"
                  shape="circle"
                  size="large"
                  className="update_product_btn"
                  icon={
                    isOpened == false ? (
                      <EditOutlined />
                    ) : (
                      <EyeOutlined></EyeOutlined>
                    )
                  }
                  onClick={edit}
                />
              </Tooltip>
            </div>
          </div>
        </div>

        <div className="proto_breadcrumb_container my-4">
          {direct_order && article && (
            // <p className="proto_breadcrumb">{`${direct_order.data.client.name} / ${article.data.name}`}</p>
            <>
              <div className="col-10">
                <Breadcrumb className="mb-2">
                  <Breadcrumb.Item>
                    <span>
                      <UserOutlined style={{ verticalAlign: "0.7px" }} />{" "}
                      {direct_order.data.client.name}
                    </span>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <span>{direct_order.data.name}</span>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => history.back()}
                    >
                      {article.data.name}
                    </span>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <span
                      style={{
                        fontWeight: 600,
                        color: "#00468c",
                      }}
                    >
                      {option && option.data.name.toUpperCase()}{" "}
                    </span>
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
              {option.data.status.pivot.proto_confirmation === "ACCEPTED" && (
                <div className="col-2">
                  <Tag
                    icon={<CheckOutlined />}
                    style={{
                      borderRadius: "15px",
                      padding: "5px 9px 5px 9px",
                    }}
                    color="#00468c"
                  >
                    Approved
                  </Tag>
                </div>
              )}
            </>
          )}
        </div>
        {option.data.status.id !== 6 && (
          <div className="steps_progress mt-4">
            {/*    <Steps
              current={option.data.status.id - 1}
              labelPlacement={"vertical"}
            >
              <Step title="PROTO" />
              <Step title="PRE SMS" />
              <Step title="SMS" />
              <Step title="OK PROD" />
              <Step title="PRODUCTION" />
            </Steps> */}
            <div>
              <Steps
                current={option.data.status.id - 1}
                labelPlacement={"vertical"}
              >
                <Step
                  title="PROTO"
                  onClick={() => setSetp("PROTO")}
                  style={{
                    cursor:
                      option?.data.status.id >= 1 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    option?.data.status.id >= 1 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="PRE SMS"
                  onClick={() => setSetp("PRE SMS")}
                  style={{
                    cursor:
                      option?.data.status.id >= 2 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    option?.data.status.id >= 2 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="SMS"
                  onClick={() => setSetp("SMS")}
                  style={{
                    cursor:
                      option?.data.status.id >= 3 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    option?.data.status.id >= 3 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="OK PROD"
                  onClick={() => setSetp("OK PROD")}
                  style={{
                    cursor:
                      option?.data.status.id >= 4 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    option?.data.status.id >= 4 && isOpened == false
                      ? "View details"
                      : ""
                  }
                />
                <Step
                  title="PRODUCTION"
                  style={{
                    cursor:
                      option?.data.status.id >= 5 && isOpened == false
                        ? "pointer"
                        : "",
                  }}
                  description={
                    option?.data.status.id >= 5 && isOpened == false
                      ? "View details"
                      : ""
                  }
                  onClick={() => setSetp("PRODUCTION")}
                />
              </Steps>
            </div>
            {isOpened == false ? (
              <>
                {" "}
                <div className="proto_footer mt-5">
                  <table
                    className="table_production "
                    style={{
                      marginBottom: "25px",
                      borderRadius: "1em",
                    }}
                  >
                    <tr className="border">
                      <th
                        className="border-right p-3"
                        style={{ width: "300px" }}
                      >
                        style
                      </th>{" "}
                      <td className="p-3" style={{ width: "300px" }}>
                        {(option.data.style_file !== null &&
                          (option.data.style_file.slice(-4) == ".pdf" ? (
                            <a
                              href={
                                process.env.REACT_APP_STORAGE_URL +
                                option.data.style_file
                              }
                              className="
                           text-center"
                              target="_blank"
                              style={{
                                textDecoration: "none",
                                color: "#00468C",
                              }}
                            >
                              {option && option.data.style}{" "}
                              <FontAwesomeIcon icon={faFilePdf} />
                            </a>
                          ) : (
                            <>
                              <a
                                href={
                                  process.env.REACT_APP_STORAGE_URL +
                                  option.data.style_file
                                }
                                className="
                           text-center"
                                target="_blank"
                                style={{
                                  textDecoration: "none",
                                  color: "#00468C",
                                }}
                              >
                                {option && option.data.style}{" "}
                                <FontAwesomeIcon icon={faImage} />
                              </a>
                            </>
                          ))) || <>{option.data.style}</>}
                      </td>
                    </tr>

                    <tr className="border">
                      <th className="border-right p-3">Fabric</th>
                      <td className="p-3" style={{ width: "300px" }}>
                        {(option.data.fabric_file !== null &&
                          (option.data.fabric_file.slice(-4) == ".pdf" ? (
                            <a
                              href={
                                process.env.REACT_APP_STORAGE_URL +
                                option.data.fabric_file
                              }
                              className="
                           text-center"
                              target="_blank"
                              style={{
                                textDecoration: "none",
                                color: "#00468C",
                              }}
                            >
                              {option && option.data.fabric}{" "}
                              <FontAwesomeIcon icon={faFilePdf} />
                            </a>
                          ) : (
                            <>
                              <a
                                href={
                                  process.env.REACT_APP_STORAGE_URL +
                                  option.data.fabric_file
                                }
                                className="
                           text-center"
                                target="_blank"
                                style={{
                                  textDecoration: "none",
                                  color: "#00468C",
                                }}
                              >
                                {option && option.data.fabric}{" "}
                                <FontAwesomeIcon icon={faImage} />
                              </a>
                            </>
                          ))) || <>{option.data.fabric}</>}
                      </td>
                    </tr>

                    <tr className="border">
                      <th className="border-right p-3">Wash</th>

                      <td className="p-3" style={{ width: "300px" }}>
                        {(option.data.wash_file !== null &&
                          (option.data.wash_file.slice(-4) == ".pdf" ? (
                            <a
                              href={
                                process.env.REACT_APP_STORAGE_URL +
                                option.data.wash_file
                              }
                              className="
                           text-center"
                              target="_blank"
                              style={{
                                textDecoration: "none",
                                color: "#00468C",
                              }}
                            >
                              {option && option.data.wash}{" "}
                              <FontAwesomeIcon icon={faFilePdf} />
                            </a>
                          ) : (
                            <>
                              <a
                                href={
                                  process.env.REACT_APP_STORAGE_URL +
                                  option.data.wash_file
                                }
                                className="
                           text-center"
                                target="_blank"
                                style={{
                                  textDecoration: "none",
                                  color: "#00468C",
                                }}
                              >
                                {option && option.data.wash}{" "}
                                <FontAwesomeIcon icon={faImage} />
                              </a>
                            </>
                          ))) || <>{option.data.wash}</>}
                      </td>
                    </tr>

                    <tr className="border">
                      <th className="border-right p-3">Trims</th>
                      <td className="p-3" style={{ width: "300px" }}>
                        {(option.data.trims_file !== null &&
                          (option.data.trims_file.slice(-4) == ".pdf" ? (
                            <a
                              href={
                                process.env.REACT_APP_STORAGE_URL +
                                option.data.trims_file
                              }
                              className="
                           text-center"
                              target="_blank"
                              style={{
                                textDecoration: "none",
                                color: "#00468C",
                              }}
                            >
                              {option && option.data.trims}{" "}
                              <FontAwesomeIcon icon={faFilePdf} />
                            </a>
                          ) : (
                            <>
                              <a
                                href={
                                  process.env.REACT_APP_STORAGE_URL +
                                  option.data.trims_file
                                }
                                className="
                           text-center"
                                target="_blank"
                                style={{
                                  textDecoration: "none",
                                  color: "#00468C",
                                }}
                              >
                                {option && option.data.trims}{" "}
                                <FontAwesomeIcon icon={faImage} />
                              </a>
                            </>
                          ))) || <>{option.data.trims}</>}
                      </td>
                    </tr>

                    <tr className="border">
                      <th className="border-right p-3">Thread</th>

                      <td className="p-3" style={{ width: "300px" }}>
                        {(option.data.thread_file !== null &&
                          (option.data.thread_file.slice(-4) == ".pdf" ? (
                            <a
                              href={
                                process.env.REACT_APP_STORAGE_URL +
                                option.data.thread_file
                              }
                              className="
                           text-center"
                              target="_blank"
                              style={{
                                textDecoration: "none",
                                color: "#00468C",
                              }}
                            >
                              {option && option.data.thread}{" "}
                              <FontAwesomeIcon icon={faFilePdf} />
                            </a>
                          ) : (
                            <>
                              <a
                                href={
                                  process.env.REACT_APP_STORAGE_URL +
                                  option.data.thread_file
                                }
                                className="
                           text-center"
                                target="_blank"
                                style={{
                                  textDecoration: "none",
                                  color: "#00468C",
                                }}
                              >
                                {option && option.data.thread}{" "}
                                <FontAwesomeIcon icon={faImage} />
                              </a>
                            </>
                          ))) || <>{option.data.thread}</>}
                      </td>
                    </tr>

                    {option.data.allStatus.map((el: any) => {
                      return (
                        <>
                          {el.name == step && el.name != "PROTO" ? (
                            <>
                              {" "}
                              <tr className="border">
                                <th className="border-right p-3">
                                  Quantity {el.name}
                                </th>
                                <td className="p-3">
                                  {el.pivot.qty != 1 ? el.pivot.qty : "-"}
                                </td>
                              </tr>
                              <tr className="border">
                                <th className="border-right p-3">
                                  Size's quantity {el.name}
                                </th>
                                <td className="p-3">
                                  {el.pivot.size_qty || "-"}
                                </td>
                              </tr>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      );
                    })}
                    {/*    */}
                    {step == "PROTO" && (
                      <>
                        {" "}
                        <tr className="border">
                          <th className="border-right p-3">Quantity Proto</th>
                          <td className="p-3">{option && option.data.qty}</td>
                        </tr>
                        <tr className="border">
                          <th className="border-right p-3">
                            Size's quantity Proto
                          </th>
                          <td className="p-3">
                            {option && option.data.size_qty}
                          </td>
                        </tr>
                      </>
                    )}

                    <tr className="border">
                      <th className="border-right p-3">Length</th>
                      <td className="p-3">
                        {(option && option.data.crotch) || "-"}
                      </td>
                    </tr>
                    {option.data.allStatus.map((el: any) => {
                      {
                        return (
                          <>
                            {el.name == step ? (
                              <>
                                {/*     <tr className="border">
                                  <th className="border-right p-3">
                                    Date trims wearhouse
                                  </th>
                                  <td className="p-3">
                                    {option && el.pivot.date_trims_wearhouse
                                      ? moment(
                                          el.pivot.date_trims_wearhouse
                                        ).format("YYYY-MM-DD")
                                      : "-"}
                                  </td>
                                </tr>
                                <tr className="border">
                                  <th className="border-right p-3">
                                    Date fabric wearhouse
                                  </th>
                                  <td className="p-3">
                                    {option && el.pivot.date_fabric_wearhouse
                                      ? moment(
                                          el.pivot.date_fabric_wearhouse
                                        ).format("YYYY-MM-DD")
                                      : "-"}
                                  </td>
                                </tr> */}
                                <tr className="border">
                                  <th className="border-right p-3">
                                    Start production date
                                  </th>
                                  <td className="p-3">
                                    {option && el.pivot.start_production_date
                                      ? moment(
                                          el.pivot.start_production_date
                                        ).format("YYYY-MM-DD")
                                      : "-"}
                                  </td>
                                </tr>
                                <tr className="border">
                                  <th className="border-right p-3">
                                    Shipping date
                                  </th>
                                  <td className="p-3">
                                    {option && el.pivot.shipping_date
                                      ? moment(el.pivot.shipping_date).format(
                                          "YYYY-MM-DD"
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                                <tr className="border">
                                  <th className="border-right p-3">
                                    Delivery date
                                  </th>
                                  <td className="p-3">
                                    {option && el.pivot.delivery_date
                                      ? moment(el.pivot.delivery_date).format(
                                          "YYYY-MM-DD"
                                        )
                                      : "-"}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        );
                      }
                    })}
                    {/*    <tr className="border">
                      <th className="border-right p-3">Quantity </th>
                      <td className="p-3">
                        {(option && option.data.status.pivot.qty) || "-"}
                      </td>
                    </tr>
                   */}
                  </table>
                </div>
              </>
            ) : (
              <>
                {" "}
                <div className="proto_breadcrumb_container">
                  <div>
                    <div>
                      <div className="proto_footer_btns my-4">
                        <Button
                          type="default"
                          className="cancel_btn"
                          style={{ height: "40px" }}
                          onClick={() => showCancelDrawer()}
                        >
                          Cancel
                        </Button>

                        <>
                          {option.data.status.id !== 5 ? (
                            <div style={{ marginLeft: "25px" }}>
                              <Select
                                showSearch
                                placeholder="Select Step"
                                optionFilterProp="children"
                                // onChange={onChange}
                                onSearch={onSearch}
                                onSelect={onChange}
                                filterOption={(input, option) =>
                                  (option!.children as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                size={"large"}
                                style={{
                                  width: 150,

                                  borderRadius: "5px",
                                }}
                                defaultValue={option.data.status.name}
                              >
                                <Option
                                  value="1"
                                  disabled={option.data.status.id >= 1}
                                >
                                  PROTO
                                </Option>
                                <Option
                                  value="2"
                                  disabled={option.data.status.id >= 2}
                                >
                                  PRE SMS
                                </Option>
                                <Option
                                  value="3"
                                  disabled={option.data.status.id >= 3}
                                >
                                  SMS
                                </Option>
                                <Option
                                  value="4"
                                  disabled={option.data.status.id >= 4}
                                >
                                  OK PROD
                                </Option>
                                <Option
                                  value="5"
                                  disabled={option.data.status.id >= 5}
                                >
                                  PRODUCTION
                                </Option>
                              </Select>{" "}
                            </div>
                          ) : (
                            <>
                              <Button
                                type="default"
                                className="approve_btn"
                                onClick={() =>
                                  approve(
                                    direct_order?.data.client.id,
                                    option.data.status.id
                                  )
                                }
                                disabled={
                                  option.data.status.pivot
                                    .proto_confirmation === "ACCEPTED"
                                }
                              >
                                Approve
                              </Button>
                            </>
                          )}
                        </>
                      </div>
                      <div className="mb-4">
                        {option.data.status.id !== 5 && (
                          <>
                            <label className="mr-3 mb-0"> Proto</label>
                            <Input
                              type="text"
                              defaultValue={
                                proto || option.data.status.pivot.proto
                              }
                              onChange={handleChangeProto}
                              style={{
                                borderRadius: "5px",
                              }}
                            ></Input>
                          </>
                        )}
                        {(option.data.status.id == 5 ||
                          option.data.status.id == 4 ||
                          option.data.status.id == 3 ||
                          option.data.status.id == 2 ||
                          option.data.status.id == 1) && (
                          <>
                            <label className="mr-3 mb-0"> Quantity </label>

                            <Input
                              type="text"
                              defaultValue={option.data.status.pivot.qty || qty}
                              style={{
                                borderRadius: "5px",
                                marginBottom: "15px",
                              }}
                              onChange={(e: any) => setQty(e.target.value)}
                            ></Input>
                            <label className="mr-3 mb-0">
                              Size's Quantity{" "}
                            </label>

                            <Input
                              type="text"
                              style={{
                                borderRadius: "5px",
                                marginBottom: "15px",
                              }}
                              defaultValue={
                                option.data.status.pivot.size_qty || size_qty
                              }
                              placeholder="S:10;M:10"
                              onChange={(e: any) => setSizeQty(e.target.value)}
                            ></Input>
                          </>
                        )}

                        <label className="mr-3 mb-0">Delivery date</label>
                        <Input
                          type="date"
                          style={{
                            borderRadius: "5px",
                            marginBottom: "15px",
                          }}
                          value={
                            deliverydate ||
                            moment(
                              option.data.status.pivot.delivery_date
                            ).format("YYYY-MM-DD")
                          }
                          onChange={handleChangeDeliveryDate}
                        ></Input>

                        <label className="mr-3 mb-0">
                          {" "}
                          Start production date{" "}
                        </label>
                        <Input
                          type="date"
                          value={
                            startDate ||
                            moment(
                              option.data.status.pivot.start_production_date
                            ).format("YYYY-MM-DD")
                          }
                          onChange={handleChangeStartDate}
                          style={{
                            borderRadius: "5px",
                            marginBottom: "15px",
                          }}
                        ></Input>
                        <label className="mr-3 mb-0"> Shipping date </label>
                        <Input
                          type="date"
                          value={
                            shippingDate ||
                            moment(
                              option.data.status.pivot.shipping_date
                            ).format("YYYY-MM-DD")
                          }
                          onChange={handleChangeShippingDate}
                          style={{
                            borderRadius: "5px",
                            marginBottom: "15px",
                          }}
                        ></Input>
                        {/*     <label className="mr-3 mb-0">
                          Date trims wearhouse
                        </label>
                        <Input
                          type="date"
                          style={{
                            borderRadius: "5px",
                            marginBottom: "15px",
                          }}
                          value={
                            datetirmswearhouse ||
                            moment(
                              option.data.status.pivot.date_trims_wearhouse
                            ).format("YYYY-MM-DD")
                          }
                          onChange={handleChangeDateTirmswearhouse}
                        ></Input> */}
                        {/*   <label className="mr-3 mb-0">
                          Date fabric wearhouse{" "}
                        </label>
                        <Input
                          type="date"
                          style={{
                            borderRadius: "5px",
                            marginBottom: "15px",
                          }}
                          value={
                            datefabricwearhouse ||
                            moment(
                              option.data.status.pivot.date_fabric_wearhouse
                            ).format("YYYY-MM-DD")
                          }
                          onChange={handleChangeDateFabricwearhouse}
                        ></Input> */}
                      </div>
                      {isOpened == true && (
                        <div>
                          <textarea
                            rows={4}
                            name="comment"
                            placeholder="Add client comment"
                            className="comment_proto_order my-4"
                            onChange={(e: any) => setComment(e.target.value)}
                            disabled={option.data.comments?.length > 0}
                          ></textarea>
                        </div>
                      )}

                      <div className="proto_footer_btns my-4">
                        <Button
                          type="default"
                          className="cancel_btn mr-4"
                          onClick={() => valider(option.data.status.id)}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/*  {option.data.status.id == 4 &&
              !option.data.status.pivot.start_production_date && (
                <div>
                  <div className="proto_breadcrumb_container">
                    {option && option.data.status.id === 4 && (
                      <table
                        className="table_production "
                        style={{
                          marginBottom: "25px",
                          borderRadius: "1em",
                        }}
                      >
                        <tr className="border">
                          <th className="border-right p-3">qty</th>
                          <td className="p-3">{option && option.data.qty}</td>
                        </tr>
                      </table>
                    )}
                    <label className="mr-3 mb-0"> Start production date </label>
                    <Input
                      type="date"
                      value={startDate}
                      onChange={handleChangeStartDate}
                      style={{
                        borderRadius: "5px",
                        marginBottom: "15px",
                      }}
                    ></Input>
                    <label className="mr-3 mb-0"> Shipping date </label>
                    <Input
                      type="date"
                      value={shippingDate}
                      onChange={handleChangeShippingDate}
                      style={{
                        borderRadius: "5px",
                        marginBottom: "15px",
                      }}
                    ></Input>
                    <label className="mr-3 mb-0">date 2 </label>
                    <Input
                      type="date"
                      style={{
                        borderRadius: "5px",
                        marginBottom: "15px",
                      }}
                    ></Input>
                    <label className="mr-3 mb-0"> date 3 </label>
                    <Input
                      type="date"
                      style={{
                        borderRadius: "5px",
                        marginBottom: "15px",
                      }}
                    ></Input>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "25px",
                    }}
                  >
                    <Button
                      onClick={() => valider(option.data.status.id)}
                      style={{
                        fontSize: "20px",
                        paddingLeft: "0",
                        paddingRight: "3",
                        width: "260px",
                        height: "50px",
                        alignSelf: "flex-end",
                        borderRadius: "5px",
                      }}
                    >
                      valider
                    </Button>
                  </div>
                </div>
              )} */}
            {/*    {isOpened && (
              <>
                {option.data.status.id == 1 && option.data.status.pivot.proto && (
                  <div className="proto_breadcrumb_container">
                    <label className="mr-3 mb-0"> Proto</label>
                    <Input
                      type="text"
                      defaultValue={option.data.status.pivot.proto}
                      onChange={handleChangeProto}
                      style={{
                        borderRadius: "5px",
                      }}
                    ></Input>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "25px",
                      }}
                    >
                      <Button
                        onClick={() => valider(option.data.status.id)}
                        style={{
                          fontSize: "20px",
                          paddingLeft: "0",
                          paddingRight: "3",
                          width: "260px",
                          height: "50px",
                          alignSelf: "flex-end",
                          borderRadius: "5px",
                        }}
                      >
                        valider
                      </Button>
                    </div>
                  </div>
                )}

                {option.data.status.id == 4 &&
                  option.data.status.pivot.start_production_date !== null && (
                    <div className="proto_breadcrumb_container">
                      <label className="mr-3 mb-0">
                        {" "}
                        Start production date aaa{" "}
                      </label>
                      <Input
                        type="date"
                        value={moment(
                          option.data.status.pivot.start_production_date
                        )
                          .utc()
                          .format("YYYY-MM-DD")}
                        onChange={handleChangeStartDate}
                        style={{
                          borderRadius: "5px",
                          marginBottom: "15px",
                        }}
                      ></Input>
                      <label className="mr-3 mb-0"> Shipping date </label>
                      <Input
                        type="date"
                        value={moment(option.data.status.pivot.shipping_date)
                          .utc()
                          .format("YYYY-MM-DD")}
                        onChange={handleChangeShippingDate}
                        style={{
                          borderRadius: "5px",
                          marginBottom: "15px",
                        }}
                      ></Input>
                      <label className="mr-3 mb-0">date 2 </label>
                      <Input
                        type="date"
                        style={{
                          borderRadius: "5px",
                          marginBottom: "15px",
                        }}
                      ></Input>
                      <label className="mr-3 mb-0"> date 3 </label>
                      <Input
                        type="date"
                        style={{
                          borderRadius: "5px",
                          marginBottom: "15px",
                        }}
                      ></Input>

                      <Button onClick={() => valider(option.data.status.id)}>
                        valider
                      </Button>
                    </div>
                  )}
              </>
            )}
 */}
          </div>
        )}
        <div className="proto_footer">
          <div className="mt-4">
            <p>{option && option.data.status.description}</p>
          </div>
          {/*   {option.data.status.id === 3 && (
            <div className="final_order_select my-3">
              <label className="mr-3 mb-0">FINAL ORDER</label>
              <Select
                disabled
                value={option.data.status.pivot.qty}
                style={{
                  width: "100%",
                }}
                dropdownStyle={{
                  borderRadius: 10,
                  fontWeight: 600,
                  fontSize: 20,
                }}
                suffixIcon={() => <FontAwesomeIcon icon={faCaretDown} />}
              >
                <Option value="">Select the number of pieces</Option>
                <Option value="1">1 Pc</Option>
                <Option value="2">2 Pcs</Option>
                <Option value="3">3 Pcs</Option>
                <Option value="4">4 Pcs</Option>
                <Option value="5">5 Pcs</Option>
              </Select>
            </div>
          )} */}

          {isOpened == false && (
            <>
              {option && option.data.allComment.length > 0 ? (
                <>
                  {/*   <List
                    itemLayout="horizontal"
                    dataSource={option.data.comments}
                    bordered
                    style={{ borderRadius: 8, background: "white" }}
                    renderItem={(item: any) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <Avatar
                              size="large"
                              src={
                                direct_order && direct_order.data.client
                                  ? process.env.REACT_APP_STORAGE_URL +
                                    direct_order.data.client.logo
                                  : avatar_placeholder
                              }
                            />
                          }
                          title={<span>{direct_order?.data.client.name}</span>}
                          description={
                            <div className="d-flex flex-column">
                              <span>
                                <span
                                  style={{ fontWeight: 500, color: "black" }}
                                >
                                  Status:{" "}
                                </span>
                                {item?.description?.includes("NOT")
                                  ? " NOT APPROVED"
                                  : " APPROVED"}
                              </span>
                              <span>
                                <span
                                  style={{ fontWeight: 500, color: "black" }}
                                >
                                  Comment:{" "}
                                </span>
                                {item?.comment?.split(":")[1] || ""}
                              </span>
                            </div>
                          }
                        />
                      </List.Item>
                    )}
                  /> */}
                  <List
                    itemLayout="horizontal"
                    dataSource={option.data.allComment}
                    renderItem={(item: any) => (
                      <>
                        <List.Item>
                          <List.Item.Meta
                            avatar={
                              <Avatar
                                src={
                                  direct_order && direct_order.data.client
                                    ? process.env.REACT_APP_STORAGE_URL +
                                      direct_order.data.client.logo
                                    : avatar_placeholder
                                }
                              />
                            }
                            title={
                              <a>
                                <span>{stepName[item?.status_id - 1]}</span>
                                {item.comment?.includes("NOT")
                                  ? " NOT APPROVED BY"
                                  : " APPROVED BY"}{" "}
                                {direct_order && direct_order.data.client.name}
                              </a>
                            }
                            description={item.comment}
                          />
                        </List.Item>
                      </>
                    )}
                  />
                </>
              ) : (
                option.data.status.id !== 5 &&
                option.data.status.id !== 6 && (
                  <h4 className="text-muted text-center">No comments</h4>
                )
              )}
            </>
          )}

          <CancelOrderDrawer
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            article={article}
            notApprovedOption={notApprovedOption}
            orderType={"direct_order"}
            productToCancel={option?.data.id}
            approvingAndCommentLoading={approvingAndCommentLoading}
            rejectOrAcceptProtoLoading={rejectOrAcceptProtoLoading}
          />
          {option.data.status.id === 6 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <h4
                className="text-center"
                style={{ color: "red", fontWeight: 400 }}
              >
                This option has been cancelled
              </h4>
              <div className="proto_footer_btns my-4">
                <Button
                  type="default"
                  className="approve_btn"
                  onClick={() =>
                    routerHistory.push(
                      `/all-clients/${params.id}/1/${direct_order?.data.id}`
                    )
                  }
                >
                  Go back to orders
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderProgress;
